import { Component, defineComponent } from '@decify/cell-shopify/client';
import { textFieldChangeEvent, textFieldName } from '../TextField';
import './RangeSlider.scss';
export const rangeSliderName = 'RangeSlider';
export const rangeSliderTagName = 'cell-component-range-slider';
export class RangeSlider extends Component {
    pushThumbs;
    elements;
    constructor() {
        super(rangeSliderName);
        const minTrackElement = this.querySelector('.RangeSlider__Track--Min');
        if (!minTrackElement) {
            throw new Error('Min track element not found');
        }
        if (!(minTrackElement instanceof HTMLInputElement)) {
            throw new Error('Min track element is not an input element');
        }
        const maxTrackElement = this.querySelector('.RangeSlider__Track--Max');
        if (!maxTrackElement) {
            throw new Error('Max track element not found');
        }
        if (!(maxTrackElement instanceof HTMLInputElement)) {
            throw new Error('Max track element is not an input element');
        }
        const minInputElement = this.querySelector('.RangeSlider__Input--Min input');
        if (!minInputElement) {
            throw new Error('Min input element not found');
        }
        if (!(minInputElement instanceof HTMLInputElement)) {
            throw new Error('Min input element is not an input element');
        }
        const maxInputElement = this.querySelector('.RangeSlider__Input--Max input');
        if (!maxInputElement) {
            throw new Error('Max input element not found');
        }
        if (!(maxInputElement instanceof HTMLInputElement)) {
            throw new Error('Max input element is not an input element');
        }
        this.elements = {
            minTrack: minTrackElement,
            maxTrack: maxTrackElement,
            minInput: minInputElement,
            maxInput: maxInputElement,
        };
        this.pushThumbs = this.props.pushThumbs;
        this.handleTrackChange = this.handleTrackChange.bind(this);
        this.handleTrackInput = this.handleTrackInput.bind(this);
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
    }
    componentDidMount() {
        this.elements.minTrack.addEventListener('change', this.handleTrackChange);
        this.elements.maxTrack.addEventListener('change', this.handleTrackChange);
        this.elements.minTrack.addEventListener('input', this.handleTrackInput);
        this.elements.maxTrack.addEventListener('input', this.handleTrackInput);
        this.subscribe(`${textFieldName}.${textFieldChangeEvent}`, this.handleTextFieldChange);
    }
    handleTrackChange() {
        this.publish('change', {
            min: parseInt(this.elements.minTrack.value),
            max: parseInt(this.elements.maxTrack.value),
        });
    }
    handleTextFieldChange(event) {
        // Check if input value as a number is smaller than the min of the range slider and return if it is.
        if (parseInt(event.value) < parseInt(this.elements.minTrack.min)) {
            return;
        }
        // Check if input value as a number is bigger than the max of the range slider and return if it is.
        if (parseInt(event.value) > parseInt(this.elements.minTrack.max)) {
            return;
        }
        // Input happened on the min input.
        if (event.element.elements.input === this.elements.minInput &&
            parseInt(event.value) < parseInt(this.elements.maxTrack.value)) {
            // Set the value of the min track to the input value.
            this.elements.minTrack.value = event.value;
        }
        // Input happened on the max input.
        if (event.element.elements.input === this.elements.maxInput &&
            parseInt(event.value) > parseInt(this.elements.minTrack.value)) {
            // Set the value of the max track to the input value.
            this.elements.maxTrack.value = event.value;
        }
        this.updateCSSCustomProperties();
    }
    handleTrackInput(event) {
        const minTrackValueNum = parseInt(this.elements.minTrack.value);
        const maxTrackValueNum = parseInt(this.elements.maxTrack.value);
        if (event.target === this.elements.minTrack) {
            if (minTrackValueNum > maxTrackValueNum) {
                if (this.pushThumbs) {
                    this.elements.maxTrack.value = minTrackValueNum.toString();
                }
                else {
                    this.elements.minTrack.value = (maxTrackValueNum - 1).toString();
                }
            }
        }
        else if (event.target === this.elements.maxTrack) {
            if (maxTrackValueNum < minTrackValueNum) {
                if (this.pushThumbs) {
                    this.elements.minTrack.value = maxTrackValueNum.toString();
                }
                else {
                    this.elements.maxTrack.value = (minTrackValueNum + 1).toString();
                }
            }
        }
        this.elements.minInput.value = this.elements.minTrack.value;
        this.elements.maxInput.value = this.elements.maxTrack.value;
        this.updateCSSCustomProperties();
    }
    updateCSSCustomProperties() {
        // Calculate the percentage of the min and max values.
        const min = parseInt(this.elements.minTrack.min);
        const max = parseInt(this.elements.minTrack.max);
        const activeRangeMinPercentage = ((parseInt(this.elements.minTrack.value) - min) / (max - min)) * 100;
        const activeRangeMaxPercentage = ((parseInt(this.elements.maxTrack.value) - min) / (max - min)) * 100;
        // Set the custom properties to update the range slider's appearance.
        this.style.setProperty('--active-range-min-percentage', `${activeRangeMinPercentage}%`);
        this.style.setProperty('--active-range-max-percentage', `${activeRangeMaxPercentage}%`);
    }
}
defineComponent(rangeSliderTagName, RangeSlider);
